"use strict";
// AUTO-GENERATED from packages/sdks/contract-sdk/idl/markets.sell-cap.json (errors
// absent from idl/markets.json) via scripts/generate-sell-cap-errors.ts.
// Do NOT edit by hand — run `pnpm --filter @morfi/errors run generate:sell-cap`.
Object.defineProperty(exports, "__esModule", { value: true });
exports.SELL_CAP_ERROR_BY_CODE = exports.SELL_CAP_ERRORS = void 0;
exports.SELL_CAP_ERRORS = {
    SellExceedsPosition: {
        code: 6079,
        name: 'SellExceedsPosition',
        msg: 'sell exceeds the tokens this trader bought in the capped market',
        module: 'markets',
    },
    InvalidTradePosition: {
        code: 6080,
        name: 'InvalidTradePosition',
        msg: "trade position account is not this trader's outcome position",
        module: 'markets',
    },
    PositionNotInitialized: {
        code: 6081,
        name: 'PositionNotInitialized',
        msg: "capped market requires the trader's initialized position; call init_position first",
        module: 'markets',
    },
    MarketNotSellCapped: {
        code: 6082,
        name: 'MarketNotSellCapped',
        msg: 'market does not cap sells, so it has no positions',
        module: 'markets',
    },
};
exports.SELL_CAP_ERROR_BY_CODE = new Map(Object.values(exports.SELL_CAP_ERRORS).map((e) => [e.code, e]));
